import type { AccountProvider, AccountType, WhatsappSession } from "../types.ts";

/** UI shape for a single connected account row. */
export type AccountSummary = {
  sessionId: string;
  provider: AccountProvider;
  accountType: AccountType;
  label: string;
  status: string;
  badge: string;          // short tag shown in the dropdown / chip ("WA", "IG", ...)
  badgeColor: string;     // hex
  subtitle: string;       // phone / username / handle
  isDefault: boolean;
};

const TYPE_BADGES: Record<string, { label: string; color: string }> = {
  whatsapp: { label: "WA", color: "#25d366" },
  instagram: { label: "IG", color: "#e1306c" },
  linkedin: { label: "IN", color: "#0a66c2" },
  telegram: { label: "TG", color: "#229ed9" },
  messenger: { label: "MS", color: "#0084ff" },
};

export function summarizeAccount(account: WhatsappSession): AccountSummary {
  const provider = (account.provider || "baileys") as AccountProvider;
  const accountType = (account.accountType || "whatsapp") as AccountType;
  const badgeMeta = TYPE_BADGES[String(accountType).toLowerCase()] || { label: "?", color: "#667781" };
  const subtitleParts: string[] = [];
  if (account.phone) {
    const digits = String(account.phone).replace(/\D+/g, "");
    if (digits) subtitleParts.push(`+${digits}`);
  }
  if (account.pushName && !subtitleParts.includes(account.pushName)) {
    subtitleParts.push(account.pushName);
  }
  return {
    sessionId: account.sessionId || "",
    provider,
    accountType,
    label: account.label?.trim()
      || account.pushName?.trim()
      || subtitleParts[0]
      || `${badgeMeta.label} ${account.sessionId?.slice(0, 6) || ""}`,
    status: account.status || "absent",
    badge: badgeMeta.label,
    badgeColor: badgeMeta.color,
    subtitle: subtitleParts.join(" · "),
    isDefault: !!account.isDefault,
  };
}

export function summarizeAccounts(accounts: WhatsappSession[] | undefined): AccountSummary[] {
  return (accounts || []).map(summarizeAccount);
}
